import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ChartsV4 from '../../services/charts';

export default function AmGaugeChart(props) {
  const { chartId, containerClass, stats, options } = props;
  const chart = useRef(null);

  useEffect(() => {
    ChartsV4.ready(() => {
      chart.current = ChartsV4.gauge(stats, chartId, options);
    });

    return () => {
      if (chart.current) {
        chart.current.dispose();
      }
    };
  });

  return <div className={containerClass} id={chartId} />;
}

AmGaugeChart.propTypes = {
  containerClass: PropTypes.string,
  chartId: PropTypes.string.isRequired,
  stats: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  options: PropTypes.shape({
    category: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    axisLimits: PropTypes.shape({
      min: PropTypes.number,
      max: PropTypes.number,
    }),
  }).isRequired,
};

AmGaugeChart.defaultProps = {
  containerClass: '',
};
